import React, { memo } from 'react';
import AccordionGroup from '../../mobile/components/AccordionGroup/AccordionGroup';
import './PowerGrid.scss';

const excludedPrescText = ['Call Me/Email Me for Power', 'Call Me/Email Me for Color', ''];

function excludePrescValues(prescValue, hyphenSybmol) {
    if (excludedPrescText.includes(prescValue) || !prescValue) return hyphenSybmol;
    return prescValue;
}

function PowerGrid(props) {
    const { prescription: { left, right, userName, labels }, view, dataLocale = {}, fromOrderDetails } = props;
    const { YOUR_POWER, HYPHEN, LEFT, RIGHT } = dataLocale;
    let itemPrescriptions;
    if (left && Object.keys(left).length) {
        itemPrescriptions = left;
    } else if (right && Object.keys(right).length) {
        itemPrescriptions = right;
    }
    let userTitle = userName || YOUR_POWER;
    if (userTitle.toLowerCase() === 'user') {
        userTitle = YOUR_POWER;
    }
    const isDesktop = view === 'desktop';
    const header = (<div className={`name-strip text-capitalize fsp14 ${isDesktop ? 'fs12 padding-t10 margin-b5 padding-l15' : 'pd-b10 pd-t10'}`}>
        <span className={`fw700 inline-block ${isDesktop ? 'padding-b5 margin-l15' : 'display-flex justify-space-between align-items-center mr-l15 mr-r15'}`}>
            <span>{userTitle}</span>
            {!isDesktop && fromOrderDetails && <span className="power-accordion-title text-color_link_blue">
                <span className="fsp12 icon icon-down-open"></span>
            </span>}
        </span>
    </div>);
    const body = (<div className={`${isDesktop ? 'padding-t5 fs12 padding-l15 padding-r15' : 'text-color_grey_black bg-color_white'}`}>
        <div className={`power-item ${isDesktop ? 'display-flex justify-content-end padding-b10' : 'pd-b10'}`}>
            <div className={`fw700 ${isDesktop ? 'padding-t20 flex-1 display-flex flex-column' : 'text-right'}`}>
                {left && <div className={`${isDesktop ? 'width25' : 'pull-right mr-l10 w16vw'}`}>{LEFT}</div>}
                {right && <div className={`${isDesktop ? 'width25' : 'pull-right w16vw'}`}>{RIGHT}</div>}
            </div>
            {itemPrescriptions && Object.keys(itemPrescriptions).map(keys => {
                if ((left && left[keys] && excludedPrescText.includes(left[keys])) && (right && right[keys] && excludedPrescText.includes(right[keys])) ||
                    (left && !left[keys]) && (right && !right[keys]) ||
                    (!left || !left[keys]) && (!right || !right[keys])) {
                    return null;
                }
                return (
                    <div data-testid="powerBlock" className={`overflow-hidden ${isDesktop ? 'full-width text-right flex-basis-20 display-flex flex-column' : 'w100'}`} key={`#left_${keys}`}>
                        <div className={`fw700 float-left ${isDesktop ? 'width100 pull-right fs12' : 'w40vw fsp12'}`}>{labels[keys]}</div>
                        {left && <div data-testid="prescValues" className={`text-right ${isDesktop ? 'width100' : 'pull-right w16vw mr-l10'}`}>{excludePrescValues(left[keys], HYPHEN)}</div>}
                        {right && <div data-testid="prescValues" className={`text-right ${isDesktop ? 'width100' : 'pull-right w16vw'}`}>{excludePrescValues(right[keys], HYPHEN)}</div>}
                    </div>
                );
            })}
        </div>
    </div>);

    return (
        <div data-testid="powerTableBlock" className={`power-table-block ${isDesktop ? 'desktop bora-8 margin-l15 margin-r15 margin-b10 margin-b10 padding-0' : 'shadow bora-4 mr-auto'}`}>
            {fromOrderDetails ? <AccordionGroup className="order-power-accordion" content={[{ header, body }]} /> : <React.Fragment>{header}{body}</React.Fragment>}
        </div>
    );
}

export default memo(PowerGrid);
